'use client';

import { c as _c } from "react/compiler-runtime";
import { TileCard } from './TileCard';
import { TileVideo } from './ui/tile-video';
import { FANTASY_RECAP } from '@/lib/fantasy-media';
interface FantasyTileProps {
  className?: string;
  onClick?: () => void;
}
export default function FantasyTile(t0) {
  const $ = _c(4);
  const {
    className,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TileVideo src={FANTASY_RECAP.web} posterSrc="/images/craft/fantasy-poster.jpg" title="Fantasy Wild West recap" className="size-full object-cover transition-transform group-hover:scale-105" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className || $[2] !== onClick) {
    t2 = <TileCard href="/fantasy" title="Fantasy Wild West" description="Something I built for my friends" className={className} onClick={onClick} gradientClassName="scrim-to-t [--scrim-color:rgb(0_0_0/0.8)]">{t1}</TileCard>;
    $[1] = className;
    $[2] = onClick;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}